import React from 'react';
import Main from './components/Main/Main';
import './App.css';


function App() {
  return (
    <div className="container-main">
      <Main />
    </div>
  );
}

export default App;
